import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {Flex} from "antd";
import {NavLink, useLocation, useParams} from "react-router-dom";
import PageLinkItem from "./PageLinkItem";
import Roles from "../../roles/Roles";

export enum Pages {
  Description = 'description',
  Criterions = 'criterions',
  ManagerTasks = 'manager-tasks',
  Dataset = 'dataset',
  Documents = 'documents',
  Factors = 'factors',
}

interface Brief {
  isAccepted: boolean,
  isPao: boolean,
}

interface PageLinksProps {
  brief: Brief,
}

interface PageLink {
  isCurrent: boolean,
  path: string,
  text: string,
  disabled: boolean,
}

export default function PageLinks({brief}: PageLinksProps) {
  const {t} = useTranslation()
  const location = useLocation()
  const routeParams = useParams()
  const briefId = Number(routeParams.id) || 0

  const path = location.pathname.split('/').pop()

  const isDescriptionPage = () => path === Pages.Description
  const isTasksPage = () => path === Pages.Criterions
  const isManagerTasksPage = () => path === Pages.ManagerTasks
  const isDatasetPage = () => path === Pages.Dataset
  const isDocumentsPage = () => path === Pages.Documents

  const isFactorsPage = () => path === Pages.Factors

  const pagesLinks = useMemo(() => {
    return [
      {
        isCurrent: isDescriptionPage(),
        path: Pages.Description,
        text: t('edit.description'),
        disabled: false,
        hide: false,
      },
      {
        isCurrent: isTasksPage(),
        path: Pages.Criterions,
        text: t('edit.tasks'),
        disabled: briefId === 0,
        hide: false,
      },
      {
        isCurrent: isManagerTasksPage(),
        path: Pages.ManagerTasks,
        text: t('edit.managerTasks'),
        disabled: briefId === 0,
        hide: false,
      },
      {
        isCurrent: isDatasetPage(),
        path: Pages.Dataset,
        text: t('edit.dataset'),
        disabled: briefId === 0,
        hide: false,
      },
      {
        isCurrent: isDocumentsPage(),
        path: Pages.Documents,
        text: t('edit.documents'),
        disabled: !brief.isAccepted || briefId === 0,
        hide: false,
      },
      {
        isCurrent: isFactorsPage(),
        path: Pages.Factors,
        text: t('edit.factors'),
        disabled: briefId === 0,
        hide: !Roles.hasAccess('canReadModel'),
      },
    ]
  }, [brief, path])

  return (
    <Flex gap={40} justify={'center'}>
      {pagesLinks.filter(pageLink => !pageLink.hide).map((pageLink: PageLink, index,) => (
        <Flex
          gap={'small'}
          className={'status-bar__item ' + (pageLink.isCurrent ? 'active' : '')}
          align={'center'}
          key={pageLink.path}
        >
          {pageLink.disabled ?
            <PageLinkItem number={index + 1} text={pageLink.text} disabled/>
            :
            <NavLink to={{pathname: `/briefs/${briefId}/${pageLink.path}`}} className={'status-bar__link'}>
              <PageLinkItem number={index + 1} text={pageLink.text}/>
            </NavLink>
          }
        </Flex>
      ))}
    </Flex>
  )
}
